'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./simple-navigation.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _simpleNavItem = require('./simple-nav-item');

var _simpleNavItem2 = _interopRequireDefault(_simpleNavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SimpleNavigation(_ref) {
  var children = _ref.children,
      orientation = _ref.orientation,
      props = _objectWithoutProperties(_ref, ['children', 'orientation']);

  var classes = (0, _classnames2.default)('simple-navigation__list', orientation && 'simple-navigation__list--orientation-' + orientation);

  return _react2.default.createElement(
    'nav',
    _extends({ className: 'simple-navigation' }, props),
    _react2.default.createElement(
      'ul',
      { className: classes },
      children
    )
  );
}

SimpleNavigation.propTypes = {
  children: _propTypes2.default.arrayOf(_simpleNavItem2.default),
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
};

SimpleNavigation.defaultProps = {
  orientation: 'horizontal'
};

exports.default = SimpleNavigation;